module.exports = "/_next/static/images/envelope-d60bd482f0bda5e403426fcd75cc8cd9.svg";